import { ref } from 'vue';

import { useApi } from './useApi';

const MANIFEST_JSON_URL = '/manifest.json';

const appManifest = ref(null);

let loadingPromise = null;

export function useAppManifest() {
    const { httpGetJson } = useApi(location.origin);

    async function load() {
        if (loadingPromise) {
            return loadingPromise;
        }

        loadingPromise = httpGetJson(MANIFEST_JSON_URL)
            .then((value) => {
                appManifest.value = value;
            })
            .catch((error) => {
                console.error(`Failed to load app manifest`, error);
            });

        return loadingPromise;
    }

    if (!appManifest.value && !loadingPromise) {
        void load(); // Fire and forget, don't await
    }

    return {
        appManifest,
    };
}
